/*
 * JTip
 * By Cody Lindley (http://www.codylindley.com)
 * Under an Attribution, Share Alike License
 * JTip is built on top of the very light weight jquery library.
 */

//on page load (as soon as its ready) call JTS_init
$(document).ready(JTS_init);

/**
* only init those that haven't already been initted
*/
function JTS_init(){
	       $('a.jTipStatic:not(.jTipInitted)')
	       .addClass('jTipInitted')
		   .hover(function(){JTS_show(this.href,this.id)},function(){$('#JTS').remove()})
           .click(function(){return false});	   
	       $("td.jTipStatic")
		   .hover(function(){
		   		JTS_show('',this.id);
				$('#' + this.id).parent().addClass('jTipActive');
			},
			function(){
				$('#JTS').remove();
				$('#' + this.id).parent().removeClass('jTipActive');
			});	   
	       $('span.jTipStatic:not(.jTipInitted)')
	       .addClass('jTipInitted')
		   .hover(function(){
		   		JTS_show('',this.id);
				$('#' + this.id).parent().addClass('jTipActive');
			},
			function(){
				$('#JTS').remove();
				$('#' + this.id).parent().removeClass('jTipActive');
			});	   
	       $('div.jTipStatic:not(.jTipInitted)')
	       .addClass('jTipInitted')
		   .hover(function(){	
		   	//alert('id:' + this.id + $('#jTip_'+this.id).width());
		   		if ($('#jTip_'+this.id).width() === undefined) {	
		   			//alert('undefined: ' + $('#jTip_'+this.id).width());   		
		   			JTS_show('',this.id);
		   		} else {
		   			JTS_show('?&width=' + $('#jTip_'+this.id).width(),this.id);
		   		}
				$('#' + this.id).parent().addClass('jTipActive');
			},
			function(){
				$('#JTS').remove();
				$('#' + this.id).parent().removeClass('jTipActive');
			});	   
	       $("div.jTipContent").hide();
}

function JTS_show(url,linkId){
	//alert('show, url: ' + url + ' linkId: ' + linkId);	
	//if(title == false)title="&nbsp;";
	var de = document.documentElement;
	var w = self.innerWidth || (de&&de.clientWidth) || document.body.clientWidth;
	//alert('de: ' + de + ' w: ' + w + ' self.innerWidth: ' + self.innerWidth + ' (de&&de.clientWidth): ' + (de&&de.clientWidth) + ' document.body.clientWidth: ' + document.body.clientWidth);
	var availAreaToRight = (w - getAbsoluteLeft(linkId)) - getWidth(linkId);
	var clickElementy = getAbsoluteTop(linkId) +20; //set y position
	//window.status='area: ' + availAreaToRight;	
	var queryString = url.replace(/^[^\?]+\??/,'');
	//alert('queryString: ' + queryString + ', url: ' + url);
	var params = parseQuery( queryString );
	if(params['width'] === undefined){params['width'] = 350};
	if(params['link'] !== undefined){
		$('#' + linkId).bind('click',function(){window.location = params['link']});
		$('#' + linkId).css('cursor','pointer');
	}
	
	// looks the same for both show on left and show on right
	var strHTML = 
	'<div id="JTS" style="width:'+params["width"]*1+'px;">' +
		'<div class="JTS_TR"></div>' +
		'<div class="JTS_inner1"><div class="JTS_inner2"><div class="JTS_copy" id="JTS_copy"><div class="JTS_loader"></div></div></div></div>' +
		'<div class="JTS_bottom">' +
			'<div class="JTS_BL"></div><div class="JTS_BR"></div><div class="JTS_middle" style="width:'+(params["width"]*1-8)+'px;"></div>' +
		'</div>' +
	'</div>';
	//alert(strHTML);
	$("body").append(strHTML);  //right side
	//var arrowOffset = getElementWidth(linkId) + 11;
	
	if (availAreaToRight>((params['width']*1)+100)){
		var clickElementx = getAbsoluteLeft(linkId) + getElementWidth(linkId) - 5; //+ arrowOffset; // set x position
	} else {
	// show to the left
		//$("body").append("<div id='JTS' style='width:"+params['width']*1+"px'><div id='JTS_shadow'></div><div id='JTS_inner'><div id='JTS_copy'><div class='JTS_loader'><div></div></div></div>");//left side
		var clickElementx = getAbsoluteLeft(linkId) - ((params['width']*1) - 0); //set x position
	}
	/* 
	clickElementy = 1141
	doc height: 1409
	div height: 336
	window height: 819
	doc scrolltop: 566
	*/
		
/*	
	$('#jTip_' + linkId).prepend(
		'doc height:' + $(document).height() + ', ' +
		'window height:' + $(window).height() + ', ' +
		' div height: ' + $('#jTip_' + linkId).height() + ', ' +
		' doc scrolltop: ' + $(document).scrollTop() + ', ' +
		' clicky: ' + clickElementy + '<br>'
	);
*/	
	
	//now move up based on where the bottom of the window is
	var distPastWindowBottom = ($('#jTip_' + linkId).height() + (clickElementy - $(document).scrollTop()) - $(window).height()) + 50;
	if (distPastWindowBottom > 0) { // want at least 10px gap, need more on chrome (different results)
		clickElementy = clickElementy - (distPastWindowBottom);
	}
	
	$('#JTS').css({left: clickElementx+"px", top: (clickElementy)+"px"});
	//$('#JTS').show();
	$('#JTS_copy').html($('#jTip_' + linkId).html());//load(url);
}

function getElementWidth(objectId) {
	x = document.getElementById(objectId);
	return x.offsetWidth;
}

function getAbsoluteLeft(objectId) {
	// Get an object left position from the upper left viewport corner
	o = document.getElementById(objectId);
	oLeft = o.offsetLeft;            // Get left position from the parent object
	while(o.offsetParent!=null) {   // Parse the parent hierarchy up to the document element
		oParent = o.offsetParent;    // Get parent object reference
		oLeft += oParent.offsetLeft; // Add parent left position
		o = oParent
	}
	return oLeft;
}

function getWidth(objectId) {
	// Get an object left position from the upper left viewport corner
	o = document.getElementById(objectId);
	oWidth = o.clientWidth;            // Get width
	return oWidth;
}

function getAbsoluteTop(objectId) {
	// Get an object top position from the upper left viewport corner
	o = document.getElementById(objectId);
	oTop = o.offsetTop;            // Get top position from the parent object
	var sTop = o.scrollTop;			// get the scroll position
	while(o.offsetParent!=null) { // Parse the parent hierarchy up to the document element
		oParent = o.offsetParent;  // Get parent object reference
		//alert('parent offsetTop: ' + oParent.offsetTop + ' scrollTop: ' + oParent.scrollTop + ' html: ' + oParent.outerHTML);
		oTop += oParent.offsetTop; // Add parent top position
		if (oParent.nodeName != 'BODY') { // or == 'DIV' ??
			sTop += oParent.scrollTop; // Add parent top scroll position, but not for the brower, only for div's
		}
		o = oParent;
	}
	
	//window.status = 'scroll: ' + sTop;
	return (oTop - sTop);
}

function parseQuery ( query ) {
   var Params = new Object ();
   if ( ! query ) return Params; // return empty object
   var Pairs = query.split(/[;&]/);
   for ( var i = 0; i < Pairs.length; i++ ) {
      var KeyVal = Pairs[i].split('=');
      if ( ! KeyVal || KeyVal.length != 2 ) continue;
      var key = unescape( KeyVal[0] );
      var val = unescape( KeyVal[1] );
      val = val.replace(/\+/g, ' ');
      Params[key] = val;
   }
   return Params;
}

function blockEvents(evt) {
              if(evt.target){
              evt.preventDefault();
              }else{
              evt.returnValue = false;
              }
}